<script lang="ts">
  import CheckMark from "../icons/CheckMark.svelte";

  interface Props {
    name: string;
    value: string | number | boolean;
    group?: string | number | boolean | undefined;
    variant?: "primary" | "secondary";
    required?: boolean;
    disabled?: boolean;
    children?: import("svelte").Snippet;
    onChange?: () => void;
  }

  let {
    name,
    value,
    group = undefined,
    variant = "primary",
    required = false,
    disabled = false,
    children,
    onChange = () => {},
  }: Props = $props();

  const checked = $derived(group === value);
</script>

<label
  class="flex text-M text-Neutral900 items-center mr-4 {disabled
    ? 'cursor-not-allowed'
    : checked
      ? 'cursor-default'
      : 'cursor-pointer'}"
>
  <span class="relative inline-flex h-8 w-8 flex-shrink-0 mr-2">
    <input
      type="radio"
      class="checkbox-input appearance-none m-0 h-8 w-8 rounded-full border cursor-[inherit]"
      data-variant={variant}
      {name}
      {value}
      {checked}
      {required}
      {disabled}
      onchange={onChange}
    />
    <!-- Visibility is driven by the input's native :checked (see <style>), NOT by
         a reactive {#if}. The checkmark is the only "checked" visual we render, and
         gating it on Svelte state let it desync from the real DOM/form state
         (bfcache restore, transition/mount races) — showing an unchecked control
         that behaved as checked. CSS reads the same native state that drives
         behavior, so the two can never diverge. -->
    <span class="checkmark-overlay pointer-events-none absolute inset-0 flex items-center justify-center">
      <CheckMark />
    </span>
  </span>
  {@render children?.()}
</label>

<style>
  .checkmark-overlay {
    opacity: 0;
  }
  .checkbox-input:checked ~ .checkmark-overlay {
    opacity: 1;
  }
</style>
